/** Geometry of the category axis, shared by its layout and its tick renderer. */
import { CHART_AXIS_FONT_SIZE } from './FmChartChrome.constants';

/** Estimated glyph width at the axis font size; an estimate, not a measurement. */
export const CATEGORY_CHAR_W = 6.6;
export const CATEGORY_LINE_H = CHART_AXIS_FONT_SIZE + 2;
export const CATEGORY_MAX_LINES = 3;
export const CATEGORY_TICK_GAP = 10;
export const CATEGORY_ROTATE_DEG = 40;
export const CATEGORY_SLOT_PADDING = 6;
/** A turned axis never takes more than this much plot height; longer labels end in "…". */
export const CATEGORY_ROTATE_MAX_HEIGHT = 96;

export interface FmCategoryAxisLayout {
  mode: 'wrap' | 'rotate';
  height: number;
  /** Lines per category label in wrap mode. */
  lines: ReadonlyMap<string, readonly string[]>;
  /** Rotate mode: characters a turned label keeps before its ellipsis. */
  maxRotatedChars?: number;
}
